import { Reducer } from 'interfaces'
import { FlushDateState } from 'interfaces/flushDate'
import { FLUSH_DATE_UPDATE, CONFIRM_UPDATE_POPUP } from 'actions/flushDateActions'

const FLUSH_DATE_INITIAL_STATE = {
  isFlushed: false,
}
const flushDate: Reducer<FlushDateState> = (prevState = FLUSH_DATE_INITIAL_STATE, action) => {
  switch (action.type) {
    case FLUSH_DATE_UPDATE: {
      return {
        ...prevState,

        backgroundFlush: action.payload.last_background_flush_at,
        prevBackgroundFlush: prevState.backgroundFlush,

        liveUpdateStarted: action.payload.last_live_update_started_at,
        prevLiveUpdateStarted: prevState.liveUpdateStarted,
      }
    }

    case CONFIRM_UPDATE_POPUP: {
      return {
        ...prevState,
        isFlushed: action.payload.isShown,
      }
    }
  }
  return prevState
}

export default flushDate
